import { OnboardingStepperSideMenu } from '../../_layout/OnboardingStepperSideMenu'
import { InvestorSignatureSideProgress } from './InvestorSignatureSideProgress'

function InvestorSignatureSideMenu() {
  return (
    <>
      <OnboardingStepperSideMenu
        customContent={<InvestorSignatureSideProgress />}
      />
    </>
  )
}

export { InvestorSignatureSideMenu }
